<script lang="ts" setup>
/* eslint-disable vue/no-v-html */
export interface AccordionItem {
    data: {
        accordion_field_name: string
        html: string
    }
}

export interface PagebuilderAccordionProps {
    data: {
        accordion_repeater: AccordionItem[]
    }
}
const props = defineProps<PagebuilderAccordionProps>()
</script>
<template>
  <Accordion class="mb-10">
    <AccordionItem
      v-for="(item, index) in props.data.accordion_repeater"
      :key="`ac-${index}`"
      :btn-index="index"
      :btn-text="item.data.accordion_field_name"
    >
      <Typo class="mx-4 mx-md-6 mb-4 mb-md-6">
        <div v-html="$formatTableHtml(item.data.html)" />
      </Typo>
    </AccordionItem>
  </Accordion>
</template>
